import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
	UpdateElevatedRequestResponse,
	OrganizationsApiService,
	StrictHttpResponse,
	UpdateElevatedRequestDto,
	CancelElevatedRequestResponse
} from '@shure/cloud/shared/organizations/data-access';

@Injectable({
	providedIn: 'root'
})
export class ElevatedAccessApiService {
	constructor(public organizationsApiService: OrganizationsApiService) {}

	/**
	 * Updates an elevated access request by sending the new status (and optional duration)
	 * to the Organizations API. Returns the full HTTP response containing the updated
	 * UpdateElevatedRequestResponse.
	 *
	 * @param elevatedRequestId - The unique ID of the elevated access request to update.
	 * @param params - The updated request payload, including status and durationMinutes (if applicable).
	 */
	public updateElevatedRequest(
		elevetedRequestId: string,
		params: UpdateElevatedRequestDto
	): Observable<StrictHttpResponse<UpdateElevatedRequestResponse>> {
		return this.organizationsApiService.updateElevatedRequest$Response({
			elevatedRequestId: elevetedRequestId,
			body: { requestStatus: params.requestStatus, durationMinutes: params.durationMinutes }
		});
	}

	/**
	 * Cancels an active elevated access request by sending a cancellation request
	 * to the Organizations API. Returns the full HTTP response containing the
	 * CancelElevatedRequestResponse with the updated request status.
	 *
	 * @param elevetedRequestId - The unique ID of the elevated access request to cancel.
	 * @returns Observable containing the HTTP response with the cancelled request details.
	 */
	public stopAccess(elevetedRequestId: string): Observable<StrictHttpResponse<CancelElevatedRequestResponse>> {
		return this.organizationsApiService.cancelElevatedRequest$Response({
			elevatedRequestId: elevetedRequestId
		});
	}
}
